import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-warning-client-questionnaire-contains-errors.',
  templateUrl: './warning-client-questionnaire-contains-errors.component.html',
  styleUrls: ['./warning-client-questionnaire-contains-errors.component.scss'],
  standalone: false,
})
export class WarningClientQuestionnaireContainsErrorsComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

}
